// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';

// Suppress ResizeObserver error overlay
window.addEventListener('error', e => {
    if (e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
        const resizeObserverErrDiv = document.getElementById(
            'webpack-dev-server-client-overlay-div'
        )
        const resizeObserverErr = document.getElementById(
            'webpack-dev-server-client-overlay'
        )
        if (resizeObserverErr) {
            resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
            resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
        e.stopImmediatePropagation()
    }
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
